/** Self-hosted Umami events (no cookies). No-op when the tracker isn't loaded. */
declare global { interface Window { umami?: { track: (event: string, data?: Record<string, string | number>) => void } } }
export function track(event: string, data?: Record<string, string | number>) {
  try { window.umami?.track(event, data) } catch { /* analytics must never break the app */ }
}
/** Only same-site relative paths are allowed as post-sign-in destinations. */
export function safeNext(v: string | null): string | null {
  return v && v.startsWith('/') && !v.startsWith('//') && !v.startsWith('/\\') ? v : null
}

/** Link to the sign-in page that returns to `next` afterwards. */
export function loginHref(next?: string, signup = false): string {
  const p = new URLSearchParams()
  if (signup) p.set('signup', '1')
  if (next && next !== '/login' && safeNext(next)) p.set('next', next)
  const q = p.toString()
  return q ? `/login?${q}` : '/login'
}
